import React from "react";
import "./App.css"
import { Header } from './components/Header';
import { Footer } from './components/Footer';
import { Hero } from './components/Hero';
import { Services } from './components/Services';
import { About } from './components/About';
import { Contact } from './components/Contact';
import { Blog } from './components/Blog';
import { BlogArticle } from './components/BlogArticle';
import { Pricing } from './components/Pricing';
import { FAQ } from './components/FAQ';
import { FavoritePlaces } from './components/FavoritePlaces';
import { PrivacyPolicy } from './components/PrivacyPolicy';
import { TermsOfService } from './components/TermsOfService';
import { HipaaNotice } from './components/HipaaNotice';
import { BlogAdmin } from './components/BlogAdmin';
import { Testimonials } from './components/Testimonials';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { Toaster } from './components/ui/toaster';
import { HomeSEO } from './components/HomeSEO';
import { BlogListSEO, ServicesSEO, AboutSEO, ContactSEO, PricingSEO, FAQSEO, FavoritesSEO, HipaaSEO, PrivacySEO, TermsSEO } from './components/SEO';
import ScrollToTop from './components/ScrollToTop';

function App() {
  return (
    <div className="App">
      <HelmetProvider>
        <Router>
          <ScrollToTop />
          <Routes>
            <Route path="/" element={
              <>
                <HomeSEO />
                <Header />
                <main>
                  <Hero />
                  <Testimonials />
                </main>
                <Footer />
              </>
            } />
            <Route path="/services" element={
              <>
                <ServicesSEO />
                <Header />
                <main>
                  <Services />
                </main>
                <Footer />
              </>
            } />
            <Route path="/about" element={
              <>
                <AboutSEO />
                <Header />
                <main>
                  <About />
                </main>
                <Footer />
              </>
            } />
            <Route path="/contact" element={
              <>
                <ContactSEO />
                <Header />
                <main>
                  <Contact />
                </main>
                <Footer />
              </>
            } />
            <Route path="/blog" element={
              <>
                <BlogListSEO />
                <Header />
                <main>
                  <Blog />
                </main>
                <Footer />
              </>
            } />
            <Route path="/blog/:slug" element={
              <>
                <Header />
                <main>
                  <BlogArticle />
                </main>
                <Footer />
              </>
            } />
            <Route path="/pricing" element={
              <>
                <PricingSEO />
                <Header />
                <main>
                  <Pricing />
                </main>
                <Footer />
              </>
            } />
            <Route path="/faq" element={
              <>
                <FAQSEO />
                <Header />
                <main>
                  <FAQ />
                </main>
                <Footer />
              </>
            } />
            <Route path="/favorite-places" element={
              <>
                <FavoritesSEO />
                <Header />
                <main>
                  <FavoritePlaces />
                </main>
                <Footer />
              </>
            } />
            <Route path="/privacy-policy" element={
              <>
                <PrivacySEO />
                <Header />
                <main>
                  <PrivacyPolicy />
                </main>
                <Footer />
              </>
            } />
            <Route path="/terms-of-service" element={
              <>
                <TermsSEO />
                <Header />
                <main>
                  <TermsOfService />
                </main>
                <Footer />
              </>
            } />
            <Route path="/hipaa-notice" element={
              <>
                <HipaaSEO />
                <Header />
                <main>
                  <HipaaNotice />
                </main>
                <Footer />
              </>
            } />
            <Route path="/admin" element={
              <>
                <BlogAdmin />
              </>
            } />
          </Routes>
        </Router>
      </HelmetProvider>
      <Toaster />
    </div>
  );
}

export default App;